import { render, staticRenderFns } from "./z-view-manager.vue?vue&type=template&id=60b33bdd&"
import script from "./z-view-manager.vue?vue&type=script&lang=js&"
export * from "./z-view-manager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports